import { render, staticRenderFns } from "./InsPlan.vue?vue&type=template&id=035d0b6c&scoped=true"
import script from "./InsPlan.vue?vue&type=script&lang=js"
export * from "./InsPlan.vue?vue&type=script&lang=js"
import style0 from "./InsPlan.vue?vue&type=style&index=0&id=035d0b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d0b6c",
  null
  
)

export default component.exports